import { SuperBannerCMSConfiguration, SuperBannerCMSConfigurationType } from "./SuperBannerCMSConfiguration";
import { SuperBannerItem, SuperBannerJackpotItem, ISuperBannerItem } from "..";
import { IClientIncludeInManager } from "../..";

export type SuperBannerConfigurationType = SuperBannerCMSConfigurationType & {
    SuperBannerItems: ISuperBannerItem[]
};

export class SuperBannerConfiguration extends SuperBannerCMSConfiguration {
    public SuperBannerItems: ISuperBannerItem[] = [];

    private GetItem(data, clientIncludeInManager:IClientIncludeInManager): ISuperBannerItem {
        if (data.JackpotId) {
            return new SuperBannerJackpotItem(data,clientIncludeInManager);
        }
        return new SuperBannerItem(data, clientIncludeInManager);
    }

    constructor(source: SuperBannerConfigurationType, clientIncludeInManager: IClientIncludeInManager) {
        super(source);
        /* istanbul ignore next */
        if (source.SuperBannerItems) {
            for (let index = 0; index < source.SuperBannerItems.length; index++) {
                let item = this.GetItem(source.SuperBannerItems[index], clientIncludeInManager);
                this.SuperBannerItems.push(item);
            }
        }
    }
}